import React,{ Component } from "react";
import './index.less'
import {IsPC} from '../../../../components/IsPc'
import Axios from '../../../../components/request/axios'

class ScrollSpan extends Component {
    state={
         news:[],
        channel__id:''
    };
    componentDidMount() {
        let _this=this;
        let channel__name='文章推荐';///默认获取第一个tab的名称
        let params={
            channel__name:channel__name
        };
        Axios.get('/api/v1/news/',params).then((res)=>{
            if(res){
                if(res.results.length <= 8){//最多加载9个
                    _this.setState({
                        news:res.results,
                        loading:false,
                        channel__id:res.results[0]?res.results[0].channel.split('/')[res.results[0].channel.split('/').length-2]:''
                    })
                }else {
                    let news=res.results.slice(0,8);
                    _this.setState({
                        news:news,
                        loading:false,
                        channel__id:res.results[0]?res.results[0].channel.split('/')[res.results[0].channel.split('/').length-2]:''
                    });
                }
                setTimeout(function () {
                    _this.ScrollImgLeft()
                },1000)
            }
        });
    }
    ScrollImgLeft=()=>{
        var speed=40;
        var MyMar = null;
        var scroll_begin = document.getElementById("scroll_begin");
        var scroll_end = document.getElementById("scroll_end");
        var scroll_div = document.getElementById("scroll_div");
        if(scroll_div){
            if(scroll_div.offsetWidth < scroll_begin.offsetWidth){
                scroll_end.innerHTML=scroll_begin.innerHTML;
            }
            MyMar=setInterval(Marquee,speed);
            scroll_div.onmouseover = function(){//鼠标移动上去，停止滚动效果
                clearInterval(MyMar);
            };
            scroll_div.onmouseout = function(){//鼠标移出去，继续滚动效果
                MyMar = setInterval(Marquee,speed);
            };
        }
        function Marquee(){
            if(scroll_end.offsetWidth-scroll_div.scrollLeft<=0) {
                scroll_div.scrollLeft=0;
            } else{
                scroll_div.scrollLeft++;
            }
        }
    };
    toNewShow=(id)=>{
        let key=this.state.channel__id;
        let hash='#/news/newshow?id='+id+"&key="+key+'&scrollspan=1';
        window.location.hash = hash;
    };
    render() {
        let {news}=this.state;
        return <div id="scroll_div" className={IsPC()?"fl pc":'fl'}>
            <div id="scroll_begin">
                {news.length>0?
                    news.map((item,index)=>{
                        return   <span key={index} className="pad_right" onClick={()=>this.toNewShow(item.id)}>{item.title}</span>
                    }):''
                }
            </div>
            <div id="scroll_end" />
        </div>
    }
}
export default ScrollSpan